/**
 * Query keys for Users API hooks
 *
 * Centralized query keys enable consistent cache invalidation across user hooks.
 */
export const usersQueryKeys = {
  all: ['users'] as const,
  employeeUsers: (filter?: string) => [...usersQueryKeys.all, 'employee-users', filter] as const,
  search: (filter: string, brand: string, limit?: number) =>
    [...usersQueryKeys.all, 'search', filter, brand, ...(limit != null ? [limit] : [])] as const,
  details: () => [...usersQueryKeys.all, 'detail'] as const,
  detail: (brand: string, userId: string) => [...usersQueryKeys.details(), brand, userId] as const,
  summaries: () => [...usersQueryKeys.all, 'summaries'] as const,
  summariesByIds: (brand: string, ids: Array<string>) => [...usersQueryKeys.summaries(), brand, { ids }] as const,
  identityProviders: () => [...usersQueryKeys.all, 'identityProviders'] as const,
  accountIdentityLists: () => [...usersQueryKeys.all, 'accountIdentityLists'] as const,
  accountIdentityList: (accountId: string) => [...usersQueryKeys.accountIdentityLists(), accountId] as const,
  identityActivityLists: () => [...usersQueryKeys.all, 'identityActivityLists'] as const,
  identityActivityList: (accountId: string) => [...usersQueryKeys.identityActivityLists(), accountId] as const,
  identityActivityEvents: (accountId: string, identityId: string) =>
    [...usersQueryKeys.identityActivityList(accountId), identityId] as const,
  velocityMembershipLists: () => [...usersQueryKeys.all, 'velocityMembershipLists'] as const,
  velocityMembershipList: (accountId: string) => [...usersQueryKeys.velocityMembershipLists(), accountId] as const,
};
